<script>
  import { Collapse } from 'element-ui'
  export default {
    name:'ElCollapse',
    extends:Collapse
  }
</script>
